import React from 'react';

// @material-ui/core
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

// components
import OrderDetail from './OrderDetail/OrderDetail';
import PaymentActionCard from '../components/PaymentActionCard';
import SupportCard from '../components/SupportCard';

// styles
import useStyles from '../../../../assets/styles/jss/pages/market/PaymentConfirmation';
import clsx from 'clsx';

const PaymentConfirmationBody = ({ order, product, membership, downloadReferences }) => {
    const classes = useStyles();

    return <Box>
        <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
                <OrderDetail order={order} product={product} membership={membership} downloadReferences={downloadReferences} />
            </Grid>
            <Grid item xs={12} md={6}>
                <Box className={clsx(classes.responsiveCard)} mb="24px">
                    <PaymentActionCard order={order} product={product} />
                </Box>
                <Box className={clsx(classes.responsiveCard)}>
                    <SupportCard />
                </Box>
            </Grid>
        </Grid>
    </Box>;
};

export default PaymentConfirmationBody;